import { ActionIcon, Tooltip } from '@mantine/core'
import { Shield } from 'lucide-react'

import { routes } from '@redwoodjs/router'

import { useAuth } from 'src/auth'
import { isAdmin } from 'src/lib/auth/permissions'

interface CarrierDirectoryLinkProps {
  /** Null while the carrier is loading or when the DOT matches no row. */
  carrierId?: string | null
}

/**
 * Jump from a VoE to the carrier's record in the admin directory.
 *
 * Internal only: the /admin routes are gated on the ADMIN role, so the link
 * uses the same check the profile menu uses for its Admin entry. Recruiters
 * never see it. Opens in a new tab because the admin surface is a separate
 * layout and the recruiter's drawer should stay where it is.
 */
const CarrierDirectoryLink = ({ carrierId }: CarrierDirectoryLinkProps) => {
  const { currentUser } = useAuth()

  if (!carrierId || !isAdmin(currentUser)) return null

  return (
    <Tooltip label="Open in carrier directory (internal)" position="top">
      <ActionIcon
        component="a"
        href={routes.adminVoeCarrier({ carrierId })}
        target="_blank"
        rel="noreferrer"
        size="xs"
        variant="subtle"
        color="gray"
        aria-label="Open in carrier directory"
      >
        <Shield size={12} />
      </ActionIcon>
    </Tooltip>
  )
}

export default CarrierDirectoryLink
